/*
* 点位采集汇总组件
* zxw
* 2025-05-25
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    Modal,
    Button,
    Image,
    ConfigProvider,
    message,
    Progress,
} from 'antd';
import {
    locale,
    // Html2pdf,
    UjoinParams,
    AddRequestHeaders,
    defaultImage,
    AliyunOSSclient,
    Base64DataUrlToArrayBuffer,
    CurrentDate,
    winHeight,
} from '../../incs/FunHelper.js';
import { saveAs } from 'file-saver';
import docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import JSZipUtils from 'jszip-utils';
import ImageModule from 'docxtemplater-image-module-free' //这句是导出图片用的
import XZTLOGO from '../../images/logo-head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

// 表格列宽
const COLWIDTH = 40;
const PLCSummary = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(props.isModalOpen);
    const [loading, setLoading] = useState(false);
    const [ulid, setUlid] = useState('');
    const [data, setData] = useState([]);
    const [fileILIPList, setFileILIPList] = useState([]);
    const [fileCELIPList, setFileCELIPList] = useState([]);

    const [showSize, setShowSize] = useState(CNF.pageSize); // 显示大小
    const [ossToken, setOssToken] = useState(null);

    const cancel = () => {
        setOpen(false);
        setLoading(false);
    }

    /**
     * 将数据转化便于写入word
     * @param {*} modal 
     * @returns 
    */
    async function toWordData(modal, retFileILIPList, retFileCELIPList) {
        //  格式化写入word的数据
        let newData = [];
        let maxConcurrency = 10;    //  最大并发数
        let currentPromises = [];   //  当前正在执行的promise
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // 数量为0，则显示为空
            item.high_ball = item.high_ball > 0 ? item.high_ball : '';
            item.double_cabins = item.double_cabins > 0 ? item.double_cabins : '';
            item.double_pinyin = item.double_pinyin > 0 ? item.double_pinyin : '';
            item.vehicle_checkpoint = item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : '';
            // 经度纬度
            item.longitude = item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[0] : '';
            item.latitude = item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[1] : '';
            // 杆高
            item.rod_height = item.installation_height ? item.installation_height : (item.rod_height > 0 ? item.rod_height + 'm' : item.installation_height > 0 ? '≥' + item.installation_height + 'm' : '')
            // 臂长
            item.arm_length = item.arm_length ? item.arm_length : ''
            if (currentPromises.length < maxConcurrency) {
                // 图片处理
                // 安装位置图片
                item.ILIPUrl = '';
                if (item.installation_location_image_path && retFileILIPList[i]?.url) {
                    let url = retFileILIPList[i].url;
                    let promise = fetch(url)
                        .then(response => response.blob())
                        .then(blob => new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result.split(',')[1]); // 分割数据URL的前缀
                            reader.onerror = error => reject(error);
                            reader.readAsDataURL(blob);
                        }))
                        .then((base64) => {
                            item.ILIPUrl = `data:image/png;base64,${base64}`;
                            return true;
                        });
                    currentPromises.push(promise);
                }

                // 接电位置图片
                item.CELIPUrl = '';
                if (item.connect_electricity_location_image_path && retFileCELIPList[i]?.url) {
                    let url = retFileCELIPList[i].url;
                    let promise = fetch(url)
                        .then(response => response.blob())
                        .then(blob => new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result.split(',')[1]); // 分割数据URL的前缀
                            reader.onerror = error => reject(error);
                            reader.readAsDataURL(blob);
                        }))
                        .then((base64) => {
                            item.CELIPUrl = `data:image/png;base64,${base64}`;
                            return true
                        });
                    currentPromises.push(promise);
                }
                newData.push(item);
                // 更新下载进度
                modal.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={(parseFloat((i + 1) / data.length * 100) - 0.01).toFixed(2)} />,
                }));
            }
            await Promise.race(currentPromises); // 等待任意一个promise完成
            let __currentPromises = [];
            for (let j = 0; j < currentPromises.length; j++) {
                let promise = currentPromises[j];
                promise.then(result => {
                    if (!result) {
                        __currentPromises.push(promise);
                    }
                });
            }
            currentPromises = __currentPromises;
        }
        return newData
    }

    /**
     * 下载图片
    */
    async function downloadImage(d, modal) {
        let retFileILIPList = fileILIPList;
        let retFileCELIPList = fileCELIPList;
        for (let i = 0; i < d.length; i++) {
            let item = d[i];
            //  避免重复下载
            if (retFileILIPList.length === 0 || i >= retFileILIPList.length) {
                //  安装位置图片
                if (item.installation_location_image_path) {
                    try {
                        let arr = item.installation_location_image_path.split('/');
                        //  去掉路径‘/’
                        let result = await AliyunOSSclient(ossToken).signatureUrl(item.installation_location_image_path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        });
                        retFileILIPList.push({
                            percent: 100,
                            url: result,
                            preview: result,
                            status: 'done',
                            path: item.installation_location_image_path,
                            name: arr[arr.length - 1],
                        });
                    } catch {
                    }
                } else {
                    retFileILIPList.push({
                        percent: 100,
                        url: '',
                        preview: '',
                        status: 'done',
                        path: '',
                        name: '',
                    });
                }
            }

            //  避免重复下载
            if (retFileCELIPList.length === 0 || i >= retFileCELIPList.length) {
                //  取电位置图片
                if (item.connect_electricity_location_image_path) {
                    try {
                        let arr = item.connect_electricity_location_image_path.split('/');
                        //  去掉路径‘/’
                        let result = await AliyunOSSclient(ossToken).signatureUrl(item.connect_electricity_location_image_path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        });
                        retFileCELIPList.push({
                            percent: 100,
                            url: result,
                            preview: result,
                            status: 'done',
                            path: item.connect_electricity_location_image_path,
                            name: arr[arr.length - 1],
                        });
                    } catch {
                    }
                } else {
                    retFileCELIPList.push({
                        percent: 100,
                        url: '',
                        preview: '',
                        status: 'done',
                        path: '',
                        name: '',
                    });
                }
            }
            // 更新下载进度
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress percent={(parseFloat((i + 1) / d.length * 100)).toFixed(2)} />,
            }));
        }
        return {
            retFileCELIPList: retFileCELIPList,
            retFileILIPList: retFileILIPList,
        }
    }

    /**
     * 导出到word
    */
    const exportWord = (newData, modal) => {
        //  初始化项目实体
        const record = props.record;
        //  设置模板变量的值，这个就是模板里所插入的内容数据，根据需要写成动态就好了。
        //  根据换行符拆分段落
        //  格式化日期，取年与月
        let date = props.record.start_date ? props.record.start_date.split('-')[0] + '年' + props.record.start_date.split('-')[1] + '月' : '';

        let wordData = {
            projectName: record.name,
            affiliateUnit: record.affiliate_unit,
            date: date,
            plData: newData,
        };

        /**
         * 读取并获得模板文件的二进制内容，是 docxtemplater 提供的固定写法。
         * PLCS.docx是模板，React 写在 public 里，我们在导出的时候，会根据此模板来导出对应的数据。
         */
        let templatePath = '/templates/PLCS.docx';
        if (props.record.export_template) {
            templatePath = '/templates/' + props.record.export_template;
        }
        JSZipUtils.getBinaryContent(templatePath, function (error, content) {
            //  抛出异常
            if (error) {
                throw error;
            }
            //  导出图片
            var opts = {}
            opts.centered = false;       //  图片是否居中
            opts.fileType = 'docx';      //  Or pptx
            opts.getImage = function (chartId) {
                return Base64DataUrlToArrayBuffer(chartId);
            }
            //  Pass the function that return image size
            opts.getSize = function (img, tagValue, tagName) {
                return [550, 330];
            }
            var imageModule = new ImageModule(opts);

            //  创建一个 PizZip 实例，内容为模板的内容。
            let zip = new PizZip(content);
            //  创建并加载 docxtemplater 实例对象。
            let doc = new docxtemplater()
                .attachModule(imageModule)  //图片导出功能
                .loadZip(zip)
                .setOptions({
                    paragraphLoop: true,
                    linebreaks: true
                })
                .compile();

            //  生成一个代表 docxtemplater 对象的 zip 文件（不是一个真实的文件，而是在内存中的表示）
            doc.setData(wordData);
            try {
                doc.render();
            } catch (error) {
                function replaceErrors(key, value) {
                    if (value instanceof Error) {
                        return Object.getOwnPropertyNames(value).reduce(function (error, key) {
                            error[key] = value[key];
                            return error;
                        },
                            {});
                    }
                    return value;
                }
                console.log(JSON.stringify({ error: error }, replaceErrors));

                if (error.properties && error.properties.errors instanceof Array) {
                    const errorMessages = error.properties.errors
                        .map(function (error) {
                            return error.properties.explanation;
                        })
                        .join('\n');
                    console.log('errorMessages', errorMessages);
                    //    errorMessages is a humanly readable message looking like this :
                    //    'The tag beginning with 'foobar' is unopened'
                }
                throw error;
            }

            var out = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });
            new Promise(function (resolve, reject) {
                //  将目标文件对象保存为目标类型的文件，并命名。
                try {
                    saveAs(out, record.name + '前端点位勘察表' + CurrentDate() + '.docx');
                    resolve();
                } catch {
                    reject();
                }
            }).then(() => {
                // 完成下载
                modal.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={100} />,
                }));
                //  下载完成后，退出报表界面
                messageApi.success('下载成功！', CNF.messageDuration);
                setTimeout(() => {
                    Modal.destroyAll(); // 退出下载进度界面
                    cancel();
                }, CNF.messageDuration * 1000);
            }, () => {
                Modal.destroyAll(); // 退出下载进度界面
                setLoading(false);
                messageApi.error('下载失败！', CNF.messageDuration);
            })
        });
    }

    /**
     * 下载
    */
    async function download() {
        // 下载期间禁止在此下载
        if (loading) return;
        setLoading(true);
        // 弹出下载进度界面
        const modal1 = Modal.info({
            title: '前端点位勘察信息表图片初始化···',
            icon: null,
            content: <Progress percent={0} />,
            footer: null,
            keyboard: false,
        });
        let { retFileILIPList, retFileCELIPList } = await downloadImage(data, modal1);
        modal1.destroy();
        // 弹出下载进度界面
        const modal2 = Modal.info({
            title: '前端点位勘察信息表正在下载中···',
            icon: null,
            content: <Progress percent={0} />,
            footer: null,
            keyboard: false,
        });
        let newData = await toWordData(modal2, retFileILIPList, retFileCELIPList);
        exportWord(newData, modal2);
    }

    useEffect(() => {
        setOpen(props.isModalOpen);
    }, [props]);

    // 修改初始化图片
    useEffect(() => {
        setUlid(props.record.key);
        /**
         * 获取列表
         */
        const getData = () => {
            const params = {
                'collect_ulid': props.record.key,
                'status': CNF.status[0].value,
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}pointLocation/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setData(data.dat);
                        } else {
                            setData([]);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        if (props.record && props.record.key !== ulid) {
            getData();
        }
    }, [props.record, ulid, data, messageApi]);

    //  获取图片列表
    useEffect(() => {
        /**
         * 获取图片对象
         * @param {*} d 
         */
        const getDataImages = (d) => {
            let params = { 'acl': 'GetObject' }
            $.ajax({
                url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        const token = data.dat;
                        setOssToken(token);
                        for (let i = 0; i < showSize; i++) {
                            let item = d[i];
                            //  避免重复下载
                            if (fileILIPList.length === 0 || i >= fileILIPList.length) {
                                //  安装位置图片
                                if (item.installation_location_image_path) {
                                    try {
                                        let arr = item.installation_location_image_path.split('/');
                                        //  去掉路径‘/’
                                        let result = AliyunOSSclient(token).signatureUrl(item.installation_location_image_path, {
                                            expires: 3600,
                                            response: {
                                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                                            }
                                        });
                                        setFileILIPList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length] = {
                                                ...newItems[newItems.length],
                                                percent: 100,
                                                url: result,
                                                preview: result,
                                                status: 'done',
                                                path: item.installation_location_image_path,
                                                name: arr[arr.length - 1],
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    } catch {
                                    }
                                } else {
                                    setFileILIPList(prevItems => {
                                        let newItems = [...prevItems]; // 创建数组的副本
                                        newItems[newItems.length] = {
                                            ...newItems[newItems.length],
                                            percent: 100,
                                            url: '',
                                            preview: '',
                                            status: 'done',
                                            path: '',
                                            name: '',
                                        }; // 更新对象
                                        return newItems; // 返回新的数组
                                    })
                                }
                            }

                            //  避免重复下载
                            if (fileCELIPList.length === 0 || i >= fileCELIPList.length) {
                                //  取电位置图片
                                if (item.connect_electricity_location_image_path) {
                                    try {
                                        let arr = item.connect_electricity_location_image_path.split('/');
                                        //  去掉路径‘/’
                                        let result = AliyunOSSclient(token).signatureUrl(item.connect_electricity_location_image_path, {
                                            expires: 3600,
                                            response: {
                                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                                            }
                                        });
                                        setFileCELIPList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length] = {
                                                ...newItems[newItems.length],
                                                percent: 100,
                                                url: result,
                                                preview: result,
                                                status: 'done',
                                                path: item.connect_electricity_location_image_path,
                                                name: arr[arr.length - 1],
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    } catch {
                                    }
                                } else {
                                    setFileCELIPList(prevItems => {
                                        let newItems = [...prevItems]; // 创建数组的副本
                                        newItems[newItems.length] = {
                                            ...newItems[newItems.length],
                                            percent: 100,
                                            url: '',
                                            preview: '',
                                            status: 'done',
                                            path: '',
                                            name: '',
                                        }; // 更新对象
                                        return newItems; // 返回新的数组
                                    })
                                }
                            }
                        }
                    } else {
                        return '';
                    }
                }
            });
        }
        if (data.length > 0 && !ossToken) {
            getDataImages(data);
        }
    }, [data, showSize, ossToken, fileILIPList.length, fileCELIPList.length]);



    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                closable={false}
                maskClosable={true}
                open={open}
                keyboard={true}
                width={1060}
                height={winHeight}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='link'
                        type='primary'
                        onClick={download}
                        loading={loading}
                        style={{ marginRight: '24px' }}>{loading ? '下载中···' : '下载'}</Button>,
                ]}
            >
                <div id='printer-summary-info-id'>
                    <div className='print-info'
                        style={{
                            padding: '0 30px',
                            width: '960px',
                            height: winHeight - 84,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                        }}
                        onScroll={(e) => {
                            let scrollHeight = e.target.scrollHeight;  // 滚动高度
                            let clientHeight = e.target.clientHeight;  // 可见高度
                            let scrollTop = e.target.scrollTop;        // 滚动条离顶部的高度
                            if (scrollHeight - scrollTop <= clientHeight + 5) { // 滚动条到底部，逐步显示更多数据
                                setShowSize(showSize + CNF.pageSize);
                            }
                        }}
                    >
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height={'45px'} alt={CNF.companyShortName} /></Col>
                            <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} /></Col>
                        </Row>
                        <Row justify='center'><Col><h1>{props.record.name}</h1></Col></Row>
                        <Row justify='center'> <Col><p style={{ margin: 0 }}>{props.record.affiliate_unit}</p></Col></Row>
                        <Row justify='center'>
                            <Col><p style={{ margin: 0 }}>
                                {props.record.start_date ? props.record.start_date.split('-')[0] + '年' : ''}
                                {props.record.start_date ? props.record.start_date.split('-')[1] + '月' : ''}</p>
                            </Col>
                        </Row>
                        <Row justify='center'> <Col><h2>前端点位勘察信息表</h2></Col></Row>
                        <table width='100%'>
                            <tbody>
                                <tr style={{ background: '#D7D7D7', fontWeight: 'bold' }}>
                                    <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center' }}>点位编号</td>
                                    <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center' }}>派出所</td>
                                    <td colSpan='7' rowSpan='2' style={{ width: COLWIDTH * 6, textAlign: 'center' }}>点位名称</td>
                                    <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center' }}>一杆几机</td>
                                    <td colSpan='4' style={{ width: COLWIDTH * 4, textAlign: 'center' }} >机型</td>
                                    <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center' }}>杆件类型</td>
                                    <td colSpan='7' rowSpan='2' style={{ width: COLWIDTH * 7, textAlign: 'center' }}>经纬度</td>
                                </tr>
                                <tr style={{ background: '#D7D7D7', fontWeight: 'bold' }}>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>智能球</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>双舱</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>双拼</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>车辆卡口</td>
                                </tr>
                                {
                                    data && data.map((item, index) => {
                                        return <tr key={index}>
                                            <td colSpan='2' style={{ width: COLWIDTH * 2, }}>{item.number}</td>
                                            <td colSpan='2' style={{ width: COLWIDTH * 2, }}>{item.police_station}</td>
                                            <td colSpan='7' style={{ width: COLWIDTH * 6, }}>{item.name}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.rod_device_count}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.high_ball > 0 ? item.high_ball : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.double_cabins > 0 ? item.double_cabins : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.double_pinyin > 0 ? item.double_pinyin : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.installation_method}</td>
                                            <td colSpan='7' style={{ width: COLWIDTH * 7, }}>{item.longitude_latitude}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        {
                            data && data.map((item, index) => {
                                if (index >= showSize) return null;
                                return <div key={index}>
                                    <Row style={{ marginTop: '50px' }} justify='center'> <Col><h2>{props.record.affiliate_unit}前端点位勘察信息表</h2></Col></Row>
                                    <table width='100%'>
                                        <tbody>
                                            <tr>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>编号</td>
                                                <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>点位<br />名称</td>
                                                <td colSpan='4' rowSpan='2' style={{ width: COLWIDTH * 4, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>点位详细地址</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>派出<br />所</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>杆型</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>杆高/安装高度</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>臂长</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>一杆<br />几机</td>
                                                <td colSpan='4' style={{ width: COLWIDTH * 4, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>摄像机类型</td>
                                                <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>防控<br />区域</td>
                                                <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>取电<br />位置</td>
                                                <td colSpan='4' rowSpan='2' style={{ width: COLWIDTH * 4, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>经纬度</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>高空<br />球</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>双舱</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>双拼</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>车辆<br />卡口</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.number}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.name}</td>
                                                <td colSpan='4' style={{ width: COLWIDTH * 4, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.address}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.police_station}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.installation_method}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.installation_height ? item.installation_height : (item.rod_height > 0 ? item.rod_height + 'm' : item.installation_height > 0 ? '≥' + item.installation_height + 'm' : '')}</td>
                                                < td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.arm_length ? item.arm_length : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.rod_device_count}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.high_ball > 0 ? item.high_ball : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.double_cabins > 0 ? item.double_cabins : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.double_pinyin > 0 ? item.double_pinyin : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : ''}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.control_area}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.connect_electricity_location}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[0] : ''}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[1] : ''}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>安装位置：</td>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>取电位置：</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, height: 252, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    <ConfigProvider locale={locale}>
                                                        <Image
                                                            alt='安装位置'
                                                            width='100%'
                                                            src={item.installation_location_image_path && fileILIPList.length > 0 && fileILIPList.length >= index ? fileILIPList[index]?.url : null}
                                                            style={{ verticalAlign: 'top', maxWidth: '100%', height: '100%', aspectRatio: 5 / 3 }}
                                                            fallback={defaultImage}
                                                        />
                                                    </ConfigProvider>
                                                </td>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, height: 252, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    <ConfigProvider locale={locale}>
                                                        <Image
                                                            alt='取电位置'
                                                            width='100%'
                                                            src={item.connect_electricity_location_image_path && fileCELIPList.length > 0 && fileCELIPList.length >= index ? fileCELIPList[index]?.url : null}
                                                            style={{ verticalAlign: 'top', maxWidth: '100%', height: '100%', aspectRatio: 5 / 3.1 }}
                                                            fallback={defaultImage}
                                                        />
                                                    </ConfigProvider>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            })
                        }
                    </div>
                </div>
            </Modal >
        </ConfigProvider>
    );
}

export default PLCSummary;